module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-tile-icon-02.03ef4872.svg";